/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2017, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../lib/@waca/baglass/js/baglass/app/plugins/MenuActionInterface',
	'../../lib/@waca/core-client/js/core-client/utils/IsBootstrap3'
], function($, MenuActionInterface, IsBootstrap3) {
	'use strict';

	const CSSOVERRIDE_SELECTOR = 'personalMenuCssOverride';
	if ( !IsBootstrap3 ) {
		const cssEl = $(`#${CSSOVERRIDE_SELECTOR}`);
		if (cssEl.length === 0) {
			$(`<style type="text/css" id="${CSSOVERRIDE_SELECTOR}">div.popover.ba-carbon-personalMenu { transform: translate3d(100vw,48px,0) translateX(-100%) !important; }</style>`).appendTo('head');
		}
	}

	class AccountSettingsMenuController extends MenuActionInterface {

		onRender(context) {
			const { target } = context;
			if (target.plugin && target.plugin.getButtonElement){
				const button = target.plugin.getButtonElement();
				if (button) {
					button.find('svg').addClass('svgIcon').wrap('<div class="account-settings-background"/>');
				}
			}
		}

		isItemVisible() {
			return false;
		}
	}
	return AccountSettingsMenuController;
});
